export const numberRegexp = /[^0-9]/g;

export const phoneRegExp = /^(\d{2,3})(\d{3,4})(\d{4})$/;

export const phoneFormat = '$1-$2-$3';

export const emailRegexp = /^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*\.[a-zA-Z]{2,3}$/i;

export function toPhone(value: string) {
    return value.replace(numberRegexp, '').replace(phoneRegExp, phoneFormat);
}

/** 대표번호, 안심번호, 휴대폰·지역번호 */
export function formatKoreanPhone(value: string): string {
    const digits = value.replace(numberRegexp, '');

    if (/^1\d{7}$/.test(digits)) {
        return digits.replace(/^(\d{4})(\d{4})$/, '$1-$2');
    }

    if (digits.length === 12) {
        return digits.replace(/^(\d{4})(\d{4})(\d{4})$/, '$1-$2-$3');
    }

    return digits.replace(/^(02|\d{3})(\d{3,4})(\d{4})$/, '$1-$2-$3');
}

export const cookieExp = /[;=,$.]/gi;

export const businessCashRegExp = /^(\d{0,3})(\d{2,4})(\d{5})$/;
